var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { fetchConfig } from '../ProductRecoSlider/config';
import CategoryItem from './CategoryItem';
import DefaultCard from '../Card';
import { LazyProvider, useLazyLoad } from '../LazyLoad';
import Slider from '../Slider';
import useGraphQL from '../hooks/useGraphQL';
import withErrorBoundary from '../higherOrderComponents/withErrorBoundary';
/**
 * Slider config for BrandRecoslider
 */
var sliderConfig = function (cardLayout, lazyLoad) { return ({
    styleType: cardLayout ? 'type2' : 'default',
    lazyLoad: lazyLoad,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    progressBar: false,
    responsive: [
        { breakpoint: 300, settings: { slidesToShow: 2.5, slidesToScroll: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 4.5, slidesToScroll: 3 } },
        { breakpoint: 700, settings: { slidesToShow: 5.5, slidesToScroll: 4 } },
        { breakpoint: 800, settings: { slidesToShow: 6.5, slidesToScroll: 6 } },
        { breakpoint: 960, settings: { slidesToShow: 7.5, slidesToScroll: 5 } },
        { breakpoint: 1200, settings: { slidesToShow: 7.5, slidesToScroll: 6 } },
        { breakpoint: 1500, settings: { slidesToShow: 8.5, slidesToScroll: 8 } },
    ],
}); };
var defaultResponse = {
    title: 'Something went wrong... please reload to try again.',
    categories: [
        {
            cid: '',
            name: 'Something went wrong...',
            topsellerProduct: {
                image: '',
                pid: '',
            },
            tracking: {
                token: '',
            },
        },
    ],
    error: '',
};
var UnlazyCategorySlider = function (props) {
    var wasVisible = useLazyLoad();
    var apiLocale = useIntl().locale;
    var recoApi = props.recoApi, cid = props.cid;
    var _a = useGraphQL('prudsysCategoryToCategories', {
        cid: cid,
        locale: apiLocale,
    }, { url: wasVisible ? recoApi : '', fetchConfig: __assign({}, fetchConfig) }), isLoading = _a.isLoading, error = _a.error, areParamsSufficient = _a.areParamsSufficient, response = _a.response;
    var _b = useState(defaultResponse), fetchedData = _b[0], setFetchedData = _b[1];
    useEffect(function () {
        var _a;
        if ((response === null || response === void 0 ? void 0 : response.data) && ((_a = response.data.prudsysCategoryToCategories.categories) === null || _a === void 0 ? void 0 : _a.length)) {
            setFetchedData(response.data.prudsysCategoryToCategories);
        }
    }, [response]);
    // Request error (e.g. GraphQL is not reachable)
    useEffect(function () {
        if (error && wasVisible) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [wasVisible, error]);
    if (!areParamsSufficient) {
        // eslint-disable-next-line no-console
        console.error('Props are not sufficient - RDE is not being rendered');
        return React.createElement(React.Fragment, null);
    }
    // GraphQL error (e.g. needed sid cookie is not available)
    if (fetchedData.error) {
        console.error(fetchedData.error);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Slider, __assign({}, sliderConfig(true, true), { headline: isLoading ? 'Loading...' : fetchedData.title, lazyLoad: false }), isLoading && wasVisible ? (React.createElement("div", null, "Loading...")) : (fetchedData.categories.map(function (brand) { return (React.createElement(DefaultCard, { key: brand.cid },
            React.createElement(CategoryItem, __assign({}, brand)))); })))));
};
/**
 * <p style="display:none;">
 *  Props are destructered here and given a default value, so Storybook can show the default value in their prop table.
 * </p>
 * <p>
 *  This slider shows category recommendations. To use it, you just have to import it in your file and pass down the needed props.
 * </p>
 */
export var CategoryRecoSlider = function (_a) {
    var _b = _a.cid, cid = _b === void 0 ? '' : _b, _c = _a.recoApi, recoApi = _c === void 0 ? '' : _c, _d = _a.usePapi, usePapi = _d === void 0 ? false : _d;
    return (React.createElement(LazyProvider, null,
        React.createElement(UnlazyCategorySlider, { cid: cid, recoApi: recoApi, usePapi: usePapi })));
};
export default withErrorBoundary(CategoryRecoSlider, function () { return null; });
//# sourceMappingURL=index.js.map